export default __webpack_public_path__ + "static/media/highlight5.fefd8a31.jpg";